import React, { useState } from 'react';
import Aside from '../../Components/Sidebar/Aside';
import Dashboard from '../CompanyPages/Dashboard';
import Maintenance from '../Maintenance/Maintenance';
import { useTranslation } from "react-i18next";
import i18next from 'i18next';
function CompanyLayout({ menuid,setLocale ,statusid,profileid,cstatusid}) {
	console.log("cstatus id..",cstatusid)
  const [rtl, setRtl] = useState(false);
  const [dashCountSummary, setDashCountSummary] = useState(true);
  const [collapsed, setCollapsed] = useState(false);
  const [image, setImage] = useState(true);
  const [toggled, setToggled] = useState(false);

  const handleCollapsedChange = (checked) => {
    setCollapsed(checked);
  };

  const handleRtlChange = (checked) => {
    setRtl(checked);
    setLocale(checked ? 'ar' : 'en');
  };

 const handleDashCountSummary = (seting) => {
    setDashCountSummary(seting);
  };

  const handleImageChange = (checked) => {
    setImage(checked);
  };

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (

    <div className={`app ${i18next.language=="ar" ? 'rtl' : ''} ${toggled ? 'toggled' : ''}`}>
      <Aside
        image={image}
        collapsed={collapsed}
        rtl={i18next.language=="ar" ? 'true' :'false' }
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      />
    

      <Dashboard
        image={image}
        toggled={toggled}
        collapsed={collapsed}
        rtl={rtl}
        dashCountSummary={dashCountSummary}
        handleToggleSidebar={handleToggleSidebar}
        handleCollapsedChange={handleCollapsedChange}
        handleRtlChange={handleRtlChange}
        handleImageChange={handleImageChange}
        statusid={statusid}
        profileid={profileid}
        menuid={menuid}
        cstatusid={cstatusid}
        handleDashCountSummary={handleDashCountSummary}
      />
   
    </div>
  );
}

export default CompanyLayout;